import React from 'react'
import {connect} from "react-redux";
import { PageHeader } from 'react-bootstrap'

export default function NotFoundView() {
  return (
    <section className="container">
      <PageHeader>Page Not Found</PageHeader>

      <p>Sorry, the page you were looking for could not be found.</p>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/views/NotFoundView.jsx